import React from 'react';
import { FaqMain } from '../../../../types/puppyGuide';

export const faq: FaqMain = {
  title: 'Vets Want You to Know',
  faqs: [
    {
      title: 'Potty training is about positivity and consistency.',
      answer: (
        <React.Fragment>
          <p>
            Potty training should begin with developing a schedule that both you and your dog can
            follow. You may want to use a repeatable phrase, such as “bathroom” or “potty,” each
            time you take your dog to the elimination area so that they learn to associate that
            specific word with the action.
          </p>
          <p>
            Positive reinforcement is the key to successful potty training. Positive reinforcement
            will teach your puppy that they get rewarded for going to the bathroom outside. Each
            time your puppy eliminates outside, immediately reward them with verbal praise, treats,
            or a favorite toy.
          </p>
          <p>
            To learn more about the do’s and don’ts of potty training, check out this guide:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/training/evr_dg_how-to-potty-train-your-dog#potty-train-puppy"
            >
              How to Potty Train a Puppy or Adult Dog
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Socialization is more than just exposure to new things.',
      answer: (
        <React.Fragment>
          <p>
            Puppy socialization is more than just a fun way to show off your adorable new puppy.
            Helping your puppy have a variety of positive experiences out in the real world ensures
            that they have the behavioral tools to happily adjust to whatever life throws at them.
          </p>
          <p>
            However, there’s a difference between haphazard socialization and well-planned,
            behavior-focused socialization. As your dog’s advocate, your goal is to introduce your
            pup to new experiences in a way that builds confidence without forcing them into
            situations that might make them uncomfortable or nervous.
          </p>
          <p>
            Learn more about the importance of socialization and how you can be your puppy’s
            advocate here:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/puppycenter/communication/evr_dg_why_is_puppy_socialization_important"
            >
              Why Is Puppy Socialization Important?
            </a>
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://be.chewy.com/positively-trained-puppy-socialization-dos-and-donts/"
            >
              How to Socialize a Puppy: An Expert Guide to Showing Your Dog the World
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Crates should be a sanctuary—never a punishment.',
      answer: (
        <React.Fragment>
          <p>
            What is crate training? It’s the process of helping your dog learn to spend time in
            their crate—and ultimately, to adopt it as their own personal space in your home.
          </p>
          <p>
            Dogs need to gradually adjust to spending time in their crates, with lots of positive
            encouragement from you. Rush the process, and you’ll risk causing your pup stress and
            anxiety, which can create negative associations with the crate that can be difficult to
            overcome.
          </p>
          <p>
            Check out this article for a step-by-step guide on crate training:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://be.chewy.com/how-to-crate-train-a-puppy-a-step-by-step-guide-from-an-expert/"
            >
              How to Crate Train a Dog: A Step-by-Step Guide From an Expert
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Biting is part of learning for puppies.',
      answer: (
        <React.Fragment>
          <p>
            It’s normal for puppies to use their teeth during play and exploration. Like human
            babies, it’s how they learn about the world, and it plays an important role in their
            socialization.
          </p>
          <p>
            Puppies learn a lot from biting things, including other puppies, their owners, and
            inanimate objects. They receive sensory information about how hard they can bite a
            particular object, what it tastes like, and whether they should repeat that behavior or
            not.
          </p>
          <p>
            While puppy biting is a part of their growth and learning experience, there are ways
            that you can deter their nipping behaviors:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/training/puppy-biting"
            >
              How to Stop Puppy Biting
            </a>
          </p>
        </React.Fragment>
      ),
    },
    {
      title: 'Eating poop is not unusual behavior, but it shouldn’t be encouraged.',
      answer: (
        <React.Fragment>
          <p>
            Stool eating, also known as coprophagy, is actually quite normal behavior for a puppy.
            And though you may find it unpleasant, do not shout or do anything alarming when it
            happens (never punish your puppy).
          </p>
          <p>
            Reacting in a way that startles your puppy can do more harm than good, and it may even
            lead to more coprophagy and other behavioral problems.
          </p>
          <p>
            If the cause is not addressed appropriately and in a timely manner, there’s a good
            chance that eating poop could become a recurring habit for your puppy.
          </p>
          <p>
            Find out why puppies eat poop and what you can do to stop it here:
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.petmd.com/dog/puppycenter/health/evr_dg_why_do_puppies_eat_poop"
            >
              Why Do Puppies Eat Poop?
            </a>
          </p>
        </React.Fragment>
      ),
    },
  ],
};
